"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stdev = exports.sum = exports.avg = exports.max = exports.min = exports.finiteOrNull = void 0;
function finiteOrNull(number) {
    return isFinite(number) ? number : null;
}
exports.finiteOrNull = finiteOrNull;
function min(arr) {
    return Math.min(...arr);
}
exports.min = min;
function max(arr) {
    return Math.max(...arr);
}
exports.max = max;
function avg(arr) {
    const n = arr.length;
    if (n === 0)
        return 0;
    return sum(arr) / n;
}
exports.avg = avg;
function sum(arr) {
    return arr.reduce((acc, cur) => acc + cur, 0);
}
exports.sum = sum;
function stdev(arr) {
    const n = arr.length;
    if (n === 0)
        return 0;
    const mean = avg(arr);
    return Math.sqrt(arr.map((x) => Math.pow(x - mean, 2)).reduce((acc, cur) => acc + cur, 0) / n);
}
exports.stdev = stdev;
//# sourceMappingURL=math.js.map